<template>
  <div class="flow-node"><Approval :source-data="sourceData" /></div>
</template>
<script>
import Approval from './approval.vue'
export default {
  name: 'FlowNode',
  components: { Approval },
  data() {
    return {
      sourceData: {
        nodeName: this.$t('work_rule_39'),
        type: 9,
        warning: { status: true, msg: '' },
        form: {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './node.scss';
.flow-node {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
